import { FE_PREFETCH_PDP_APIS_250224 } from "@faire/retailer-settings/FE_PREFETCH_PDP_APIS_250224";
import { useAssignSetting, useSetting } from "@faire/retailer-visitor-shared/settings/__internal__/useSetting";
export var useSettingPrefetchPdpApis = function() {
    return useSetting(FE_PREFETCH_PDP_APIS_250224);
};
export var useAssignSettingPrefetchPdpApis = function() {
    return useAssignSetting(FE_PREFETCH_PDP_APIS_250224);
};
